import React from "react"

//DBSALONI LINKS
import ServicesManagment from "../pages/servicesManagment"
import OerderManagement from "../pages/orderManagement"
import Dbinvoices from "../pages/dbInvoices"
import CancellationInvoices from "../pages/CancellationInvoices"
import CustomerSettlements from "../pages/customerSettlements"
import Policy from "../pages/Policy"

import { Navigate } from "react-router-dom"

// Profile
import AccountM from "../pages/accountManagement"

//Email
import EmailInbox from "../pages/Email/email-inbox"
import EmailRead from "../pages/Email/email-read"
import EmailBasicTemplte from "../pages/Email/email-basic-templte"
import EmailAlertTemplte from "../pages/Email/email-template-alert"
import EmailTemplateBilling from "../pages/Email/email-template-billing"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

// Maps
import MapsGoogle from "../pages/Maps/MapsGoogle"
import MapsVector from "../pages/Maps/MapsVector"
import MapsLeaflet from "../pages/Maps/MapsLeaflet"

//Pages
import PagesMaintenance from "../pages/Utility/pages-maintenance"
import PagesComingsoon from "../pages/Utility/pages-comingsoon"
import Pages404 from "../pages/Utility/pages-404"
import Pages500 from "../pages/Utility/pages-500"
import CartAbandonmentPage from "../pages/cart/index"  
import Invoices from "../pages/invoices"

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/ServicesManagment", component: ServicesManagment },
  { path: "/acount-management", component: AccountM },
  { path: "/oerder-management", component: OerderManagement },
  { path: "/dbinvoices", component: Dbinvoices },
  { path: "/cancellation-invoices", component: CancellationInvoices },
  { path: "/customer-settlements", component: CustomerSettlements },
  { path: "/policy", component: Policy },
  { path: "/cart-abandonment", component: CartAbandonmentPage },
  { path: "/invoice", component: Invoices },
  //Email
  { path: "/email-inbox", component: EmailInbox },
  { path: "/email-read", component: EmailRead },
  { path: "/email-template-basic", component: EmailBasicTemplte },
  { path: "/email-template-alert", component: EmailAlertTemplte },
  { path: "/email-template-billing", component: EmailTemplateBilling },
  // Maps
  { path: "/maps-google", component: MapsGoogle },
  { path: "/maps-vector", component: MapsVector },
  { path: "/maps-leaflet", component: MapsLeaflet },
  { path: "/logout", component: Logout },
  {
    path: "/",
    exact: true,
    component: null,
    isNavigate: true,
    navigateTo: "/dashboard"
  },
]

const publicRoutes = [
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/pages-maintenance", component: PagesMaintenance },
  { path: "/pages-comingsoon", component: PagesComingsoon },
  { path: "/pages-404", component: Pages404 },
  { path: "/pages-500", component: Pages500 },
]

export { authProtectedRoutes, publicRoutes }
